import user from './User.vue'
import logo from './Logo.vue'
import sidebar from './Sidebar.vue'

export default {
	user,
	logo,
	sidebar
}